import {
  ErrorHandler,
  Injectable,
  Injector,
  NgModule,
  PLATFORM_ID,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Insights } from './insights.service';
import { isPlatformBrowser } from '@angular/common';
import { AppConfig } from '@boels/models';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  #insightsService: Insights = inject(Insights);
  #environment: AppConfig = inject<AppConfig>('ENVIRONMENT' as any);

  constructor() {
    super();
  }

  handleExternalError(error: Error | ErrorEvent) {
    const errorObject = error instanceof ErrorEvent ? error.error : error;
    this.handleError(errorObject);
  }

  override handleError(error: Error) {
    if (!error) return;

    if (!this.#environment.production) {
      super.handleError(error);
      return;
    }
    this.#insightsService.trackError(error);
  }
}

export function initTelemtryService(injector: Injector): () => void {
  return () => {
    const platform_id = injector.get(PLATFORM_ID);
    if (!isPlatformBrowser(platform_id)) return;
    const insightsService = injector.get(Insights);
    insightsService.init();

    const errorHandler = injector.get(ErrorHandler) as ErrorHandlerService;
    setupGlobalErrorHandlers(errorHandler);
  };
}

function setupGlobalErrorHandlers(errorHandler: ErrorHandlerService) {
  window.addEventListener('error', (event: ErrorEvent) => {
    errorHandler.handleExternalError(event);
  });

  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      errorHandler.handleExternalError(new Error(event.reason));
    },
  );
}

@NgModule({
  providers: [
    Insights,
    provideAppInitializer(() => {
      const initializerFn = initTelemtryService(inject(Injector));
      return initializerFn();
    }),
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
  ],
})
export class InsightsModule {}
